import type { SubscriptionStatus } from "../../types";

export function normalizePolarStatus(
  status: string,
  cancelAtPeriodEnd: boolean
): SubscriptionStatus {
  if (status === "active" && !cancelAtPeriodEnd) {
    return "active";
  }
  if (status === "active" && cancelAtPeriodEnd) {
    return "non_renewing";
  }
  if (status === "past_due") {
    return "attention";
  }
  if (status === "canceled" || status === "unpaid") {
    return "cancelled";
  }
  return "cancelled";
}

export function derivePolarEventId(
  eventType: string,
  subscriptionId: string
): string {
  return `${eventType}:${subscriptionId}`;
}
